import React, { useState, useEffect } from 'react';
import { Table } from 'react-bootstrap';
import NoDataComponent from './noData';

const TableComponent = (props) => {
    const [search, setSearch] = useState('');
    const [sortOrder, setSortOrder] = useState('');
    const [filterColumn, setFilterColumn] = useState('');
    const [filterValues, setFilterValues] = useState({});
    const [popupPosition, setPopupPosition] = useState(null);

    const handleSort = (key) => {
        let sort = 'asc';
        const val = `${key}-${sort}`;
        if (sortOrder === val) {
            sort = sort === 'asc' ? 'desc' : 'asc';
        }
        setSortOrder(`${key}-${sort}`);
    };

    useEffect(() => {
        if (sortOrder !== '') props.sort(sortOrder);
    }, [sortOrder]);

    const handleClickFilter = (e, key) => {
        e.stopPropagation();
        const rect = e.currentTarget.getBoundingClientRect();

        if (filterColumn === key) {
            // Đang mở → Đóng
            setPopupPosition(null);
            setFilterColumn('');
        } else {
            // Đang đóng hoặc từ bảng khác → Mở
            setPopupPosition({ top: rect.bottom, left: rect.left });
            setFilterColumn(key);
        }
    };

    const filterVisible =  popupPosition !== null;

    return (
        <div className={`table-responsive my-4 ${props.class || ''}`}>
            <Table hover className={`my-4 ${props.class || ''} table m-0 table--text-bold`}>
                <thead>
                <tr className="border-bt">
                    {props.column.map((i) => (
                        <th key={i.key} onClick={() => handleSort(i.key)}>
                            <div className="d-flex align-items-center justify-content-between">
                                {i.name}
                                <div className="d-flex align-items-center">
                                    {props.sort && (
                                        <div className="d-flex flex-column mx-2">
                                            <i className={`fa fa-sort-up ${sortOrder === `${i.key}-asc` ? 'active' : ''}`} />
                                            <i className={`fa fa-sort-down ${sortOrder === `${i.key}-desc` ? 'active' : ''}`} />
                                        </div>
                                    )}
                                    {props.filter && i.key === 'name' && (
                                        <i
                                            className={`fa fa-filter ${filterColumn === i.key && filterVisible ? 'text-primary' : ''}`}
                                            onClick={(e) => handleClickFilter(e, i.key)}
                                            style={{ cursor: 'pointer' }}
                                        />
                                    )}
                                </div>
                            </div>
                        </th>
                    ))}
                </tr>
                </thead>
                <tbody>
                {props.data.map((item, k) => (
                    <tr key={k}>
                    {props.column.map((i2) => (
                        <td key={`${k}-${i2.key}`}>
                        {i2.customRender ? i2.customRender(item[i2.key], item) : (
                            <>
                            {item[i2.key]?.format || item[i2.key]?.value}
                            {'percent' in (item[i2.key] || {}) && (
                                <span className="ml-4">
                                <i className={item[i2.key].percent >= 0 ? 'fa fa-sort-up' : 'fa fa-sort-down'} />{' '}
                                {item[i2.key].percent}%
                                </span>
                            )}
                            </>
                        )}
                        </td>
                    ))}
                    </tr>
                ))}
                {props.data.length === 0 && (
                    <tr>
                        <td colSpan={props.column.length}>
                            <NoDataComponent />
                        </td>
                    </tr>
                )}
                </tbody>
            </Table>

            {filterVisible && (
                <div
                    className="filter-popup bg-white border rounded shadow p-2"
                    style={{
                        top: '114px',
                        left: '145px',
                        zIndex: 1,
                        minWidth: '220px',
                        position: 'absolute'
                    }}
                    onClick={(e) => e.stopPropagation()}
                >
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <button className="btn btn-sm btn-close" onClick={() => {setPopupPosition(null);setFilterColumn('');}}>
                        </button>
                    </div>
                    <input
                        className="form-control mb-2"
                        value={filterValues[filterColumn] || ''}
                        onChange={(e) =>
                            setFilterValues((prev) => ({
                                ...prev,
                                [filterColumn]: e.target.value,
                            }))
                        }
                        placeholder="Search name"
                    />
                    <div className="d-flex justify-content-end">
                        <button
                            className="btn btn-sm btn-secondary"
                            onClick={() => {
                                setFilterValues((prev) => ({ ...prev, [filterColumn]: '' }));
                                props.handleFilterName('', filterColumn);
                                setPopupPosition(null);
                                setFilterColumn('');
                            }}
                        >
                            Reset
                        </button>
                        <button
                            style={{ marginLeft: '5px' }}
                            className="btn btn-sm btn-primary"
                            onClick={() => {
                                props.handleFilterName(filterValues[filterColumn] || '', filterColumn);
                                setPopupPosition(null);
                                setFilterColumn('');
                            }}
                        >
                            OK
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default TableComponent;